import React from 'react';
import PropTypes from 'prop-types';
import { CookiesProvider } from 'react-cookie';
import { SheetsRegistry } from 'react-jss/lib/jss';
import App from '../../components/App';
import NotificationsProvider from '../../core/notifications/NotificationsProvider';
import {
  MuiThemeProvider,
  createMuiTheme,
  jssPreset,
  createGenerateClassName,
} from '@material-ui/core/styles';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';

const theme = createMuiTheme({ typography: { useNextVariants: true } });
const sheetsManager = new Map();

const sheetsRegistry = new SheetsRegistry();
const generateClassName = createGenerateClassName();
const jss = create(jssPreset());
jss.options.insertionPoint = document.getElementById('jss-insertion-point');

class Main extends React.Component {
  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = document.getElementById('jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  render() {
    const {
      route,
      context,
      notificationInfo: { swRegistration, applicationServerKey },
    } = this.props;

    return (
      <JssProvider jss={jss} registry={sheetsRegistry} generateClassName={generateClassName}>
        <MuiThemeProvider sheetsManager={sheetsManager} theme={theme}>
          <CookiesProvider>
            <NotificationsProvider
              swRegistration={swRegistration}
              applicationServerKey={applicationServerKey}
            >
              <App context={context} route={route}>
                {route.component}
              </App>
            </NotificationsProvider>
          </CookiesProvider>
        </MuiThemeProvider>
      </JssProvider>
    );
  }
}

Main.propTypes = {
  route: PropTypes.object,
  context: PropTypes.object,
  notificationInfo: PropTypes.object,
};

export default Main;
